// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {FormattedMessage} from 'react-intl';
import InlineAlertBar from '../../../shared/components/inline-alert-bar/index';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import RgaBOCriteria from './rga-bo-report-criteria';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getRgaUnits} from '../../shared/services/fetch-service-rga';

function handleSelectAllDealers() {

    if (this.state.isDeSelectAll) {

        this.setState({
            selectedDataTypes: []
        });

    } else {

        this.setState({
            selectedDataTypes: [...this.state.dataTypes]
        });

    }
    this.setState({
        isDeSelectAll: !this.state.isDeSelectAll
    });

}

function handleDealerSelect(index, isSelected) {

    if (isSelected) {

        const selectedDataType = this.state.dataTypes.find(dataType => dataType.key === index.key);

        if (selectedDataType) {

            this.setState({
                selectedDataTypes: [...this.state.selectedDataTypes, selectedDataType]
            });

        }

    } else {

        const selectedDataType = this.state.dataTypes.find(dataType => dataType.key === index.key);

        if (selectedDataType) {

            const updatedSelectedDataTypes = this.state.selectedDataTypes.filter(dataType => dataType.key !== selectedDataType.key);

            this.setState({
                selectedDataTypes: updatedSelectedDataTypes
            });

        }

    }

}

function handleCreateReportClick() {

    this.props.actions.downloadRga(this.state.selectedDataTypes, this.state.registrationDate, this.state.responsibleUnit);

}

function handleCriteriaReset() {

    this.setState({
        registrationDate: {
            from: null,
            max: null,
            min: null,
            to: null
        },
        responsibleUnit: '',
        selectedDataTypes: []
    });

}

function handleRegistrationDateChange(registrationDateRange) {

    this.setState({
        registrationDate: {
            ...this.state.registrationDate,
            from: registrationDateRange.from,
            to: registrationDateRange.to
        }
    });

}

function onResponsibleUnitChange(responsibleUnit) {

    this.setState({
        responsibleUnit
    });

}
class RgaBOReport extends Component {

    constructor(props) {

        super(props);
        const currentDate = new Date();
        const tenYearsLater = new Date(currentDate.setFullYear(currentDate.getFullYear() + 10)).getTime();

        this.state = {
            dataTypes: [
            {key: 'NGH_HEADER', value: 'NGH HEADER'},
            {key: 'DEF_LINE', value: 'DEF LINE'},
            {key: 'DEF_INJECTOR', value: 'DEF INJECTOR'},
            {key: 'DEF_PUMP', value: 'DEF PUMP'},
            {key: 'AIR_THROTTLE', value: 'Air Throttle'},
            {key: 'EXHAUST_THROTTLE', value: 'Exhaust Throttle'},
            {key: 'EGR_VALVE', value: 'EGR Valve'},
            {key: 'MISC_SENSOR', value: 'Misc. Sensor'},
            {key: 'COMBO_SENSOR', value: 'Combo Sensor'},
            {key: 'TEMPERATURE', value: 'Temperature'},
            {key: 'PRESSURE', value: 'Pressure'},
            {key: 'EXH_GAS_TEMP', value: 'EXH GAS TEMP'},
            {key: 'NOX', value: 'NOx'},
            {key: 'TRI/QUAD_CAN', value: 'TRI/QUAD CAN'},
            {key: 'DEF_HEADER', value: 'DEF HEADER'}
            ],
            isDeSelectAll: false,
            registrationDate: {
                from: null,
                max: tenYearsLater,
                min: null,
                to: null
            },
            responsibleUnit: '',
            responsibleUnitList: [],
            selectedDataTypes: []
        };

    }

    componentWillMount() {

        getRgaUnits()
            .then(respUnitList => {

                if (!respUnitList || respUnitList.length === 0) {

                    this.setState({responsibleUnitList: []});
                    return [];

                }
                const keyValuePairs = respUnitList.map(unit => ({
                    key: unit.respUnitCode,
                    value: unit.respUnitValue
                }));

                this.setState({responsibleUnitList: keyValuePairs});
                return keyValuePairs;

            })
            .catch(() => {

                this.setState({responsibleUnitList: []});

            });

    }
    render() {

        const canRunReport = this.state.selectedDataTypes.length > 0 && this.state.registrationDate.from && this.state.registrationDate.to && this.state.registrationDate.from < this.state.registrationDate.to && this.state.responsibleUnit;

        return (
            <section className='rga-bo-report'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='rga-bo-report-title'>
                    <FormattedMessage id='RGA BO Report'/>
                </h2>
                <RgaBOCriteria
                    canRunReport={canRunReport}
                    onCreateReport={handleCreateReportClick.bind(this)}
                    onCriteriaReset={handleCriteriaReset.bind(this)}
                    onDealerSelect={handleDealerSelect.bind(this)}
                    onRegistrationDateChange={handleRegistrationDateChange.bind(this)}
                    onResponsibleUnitChange={onResponsibleUnitChange.bind(this)}
                    onSelectAllDealers={handleSelectAllDealers.bind(this)}
                    registrationDate={this.state.registrationDate}
                    responsibleUnit={this.state.responsibleUnit}
                    responsibleUnitList={this.state.responsibleUnitList}
                    selectedAccounts={this.state.dataTypes}
                    selectedDealers={this.state.selectedDataTypes}
                />
                <InlineAlertBar label='You can Download the report with specified criteria'/>
            </section>
        );

    }

}

RgaBOReport.displayName = 'RgaBOReport';
RgaBOReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    reportIsScrollable: PropTypes.bool.isRequired,
    showNoResultsFound: PropTypes.bool.isRequired
};

export default RgaBOReport;



// WEBPACK FOOTER //
// ./src/rga/reports/components/index.js